var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M16.335 8l1.415 1.415-4.67 4.587 4.67 4.583L16.335 20l-6.085-5.998L16.335 8z","fill":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }